module.exports = __webpack_public_path__ + "img/office.1d6302e2.jpg";